// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  setCustomersForSelectMonthlyRedux,
  setServicesIaUsageMonthlysListRedux,
  setServicesIaUsageMonthlysRedux,
} from './servicesIaUsageMonthlysSlice';
import {
  getServicesIaUsageMonthlysAnalyticsService,
  getCustomerOptionsMonthlyService,
} from '../../services/services-ia-usage-monthlys.service';

export const getCustomerOptionsMonthlyStore = () => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response: any = await getCustomerOptionsMonthlyService();

    if (response.ok) {
      dispatch(setCustomersForSelectMonthlyRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const getServicesIaUsageMonthlysAnalyticsStore =
  (query: any = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response: any = await getServicesIaUsageMonthlysAnalyticsService(query);

      if (response.ok) {
        dispatch(setServicesIaUsageMonthlysListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
